import React from 'react';

interface Props {
  eventType: string;
}

function hashToHue(str: string): number {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  return Math.abs(hash) % 360;
}

export function getEventTypeColor(eventType: string): string {
  const hue = hashToHue(eventType);
  return `hsl(${hue}, 70%, 45%)`;
}

export function EventTypeIndicator({ eventType }: Props) {
  const dotColor = getEventTypeColor(eventType);
  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: '6px' }}>
      <span style={{
        width: '8px',
        height: '8px',
        borderRadius: '50%',
        backgroundColor: dotColor,
        flexShrink: 0,
        display: 'inline-block',
      }} />
      {eventType}
    </span>
  );
}
